import { render, staticRenderFns } from "./CreatorCenter.vue?vue&type=template&id=5fb61a21&scoped=true"
import script from "./CreatorCenter.vue?vue&type=script&lang=js"
export * from "./CreatorCenter.vue?vue&type=script&lang=js"
import style0 from "./CreatorCenter.vue?vue&type=style&index=0&id=5fb61a21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb61a21",
  null
  
)

export default component.exports